import {isObject} from 'lodash';

const getVehiclePicker = () => import(/* webpackChunkName: "get-vehicle-picker" */ 'public/js/components/vehicle-picker.js');

// A list of classes used to open the vehicle picker
const vehiclePickerSelector = [
	'.vehiclepicker_classic',
	'.vehiclepicker',
	'.vehiclepicker_link',
	'.vehiclepicker-link',
].join(', ');

const handleOpenVehiclePicker = ({ currentTarget }, props = null) => {
	const pickerData = props || currentTarget?.dataset;
	if (!pickerData) return;
	getVehiclePicker().then((module) => {
		module.getDataAndOpenVehiclePicker(pickerData);
	});
};

// Delegated click so elements added after load also work
document.addEventListener('click', (e) => {
	const el = e.target.closest(vehiclePickerSelector);
	if (!el) return;
	e.preventDefault();
	e.stopPropagation();
	handleOpenVehiclePicker({ currentTarget: el }, null);
}, true);

// Moved this out from the vehicle picker js file to account for scenarios where this is called from custom html modules
window.openVehiclePicker = window.openVehiclePickerRedirect = (make, model = null, year = null, trim = null, engine = null, redirect = null) => {
	if (isObject(make)) {
		const { makeInfo, model, year, trim, engine, redirect } = make;
		handleOpenVehiclePicker({}, {makeInfo, model, year, trim, engine, redirect});
	} else {
		handleOpenVehiclePicker({}, {make, model, year, trim, engine, redirect});
	}
};
